module.exports = __webpack_public_path__ + "img/ics.bb8b759e.png";